import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeOfferContactButtonName = "offer_show_number" | "offer_call_investor";
type AmplitudeOfferDetailNavButtonName = "view_floor_plan" | "view_map";
type AmplitudeConstructionGalleryButtonName = "view_construction_photos" | "view_construction_stages";
type AmplitudeLocationButtonName = "check_location_map";
type AmplitudeAreaPhotosButtonName = "view_area_photos" | "view_area_map";
type AmplitudeVendorReportButtonName = "download_developer_report";
type AmplitudeCreditCalculatorButtonName = "ask_property_with_mortgage" | "view_bank_offers";
type AmplitudeComparisonWidgetButtonName = "view_comparison_offers" | "rp_go_to_comparison";
type AmplitudeFavouritesTopbarButtonName = "rp_favourites_show_all";
type AmplitudeOfferListViewButtonName = "offers_view_toggle";
type AmplitudeVendorWebsiteButtonName = "view_developer_website";
type AmplitudeGalleryContactButtonName = "rp_gallery_show_number";
type AmplitudeGalleryMapButtonName = "check_travel_time";
type AmplitudeHomeMatchOnOffModalButtonName = "rp_hm_on_off_modal_confirm";
type AmplitudePostPriceRevealButtonName = "rp_post_price_reveal_browsing_only";
type AmplitudeSearchAiAssistantButtonName = "rp_search_ai_assistant";
export type AmplitudeUnlockChoiceButtonCategory =
    | "rp_post_price_reveal"
    | "rp_download_floor_plan"
    | "rp_price_history"
    | "rp_developer_report"
    | "rp_construction_photos"
    | "rp_area_photos"
    | "rp_faq";
export type AmplitudeUnlockChoiceButtonAction = "select" | "submit" | "close";
export type AmplitudeUnlockChoiceButtonName = `${AmplitudeUnlockChoiceButtonCategory}_${AmplitudeUnlockChoiceButtonAction}`;
export type AmplitudeUnlockChoiceExitButtonName = "rp_preferences_close" | "rp_price_negotiate_submit" | "rp_price_negotiate_close";
export type AmplitudeRegistrationWizardButtonName =
    | "rp_auth_continue"
    | "rp_auth_google"
    | "rp_auth_facebook"
    | "rp_auth_send_sms"
    | "rp_auth_resend_sms"
    | "rp_auth_discover_price"
    | "rp_auth_back"
    | "rp_auth_close";
type AmplitudeListingMapButtonName = "rp_listing_map_apartment_prev" | "rp_listing_map_apartment_next" | "ask_full_offer" | "see_property_details";
export type AmplitudePersonalizedHomepageButtonName =
    | "rp_homepage_recent_search"
    | "rp_homepage_recent_searches_show_more"
    | "rp_homepage_offers_for_you"
    | "rp_homepage_youtube_video"
    | "rp_homepage_youtube_channel"
    | "rp_homepage_consultant_call"
    | "rp_homepage_prices_show_more"
    | "rp_homepage_tinder_rate"
    | "rp_homepage_tinder_more_info"
    | "rp_homepage_tinder_see_all"
    | "rp_homepage_tinder_close";
export type AmplitudeReservationButtonName =
    | "rp_reservation_start"
    | "rp_reservation_code_submit"
    | "rp_reservation_code_resend"
    | "rp_reservation_close"
    | "rp_reservation_confirmed_close";
// the steps of the reservation started from the offer choice of the unlock choice modal
export type AmplitudeUnlockChoiceReservationButtonName = "rp_reservation_back" | "rp_reservation_close" | "rp_reservation_resend" | "rp_reservation_ack";
export type AmplitudePricesCityButtonName =
    | "rp_apartment_prices_area"
    | "rp_apartment_prices_place"
    | "rp_apartment_prices_nearby_offers_arrow"
    | "rp_apartment_prices_price_stat";
export type AmplitudeApartmentPricesButtonName =
    | "rp_apartment_prices_place"
    | "rp_apartment_prices_short"
    | "rp_apartment_prices_shorts_arrow"
    | "rp_apartment_prices_faq_arrow"
    | "rp_apartment_prices_cheapest_offers_arrow"
    | "rp_apartment_prices_popular_location";
export type AmplitudeHotlineConsultantButtonName = "rp_hotline_consultant_show_similar";

type AmplitudeButtonName =
    | AmplitudeOfferContactButtonName
    | AmplitudeOfferDetailNavButtonName
    | AmplitudeConstructionGalleryButtonName
    | AmplitudeLocationButtonName
    | AmplitudeAreaPhotosButtonName
    | AmplitudeVendorReportButtonName
    | AmplitudeCreditCalculatorButtonName
    | AmplitudeComparisonWidgetButtonName
    | AmplitudeOfferListViewButtonName
    | AmplitudeVendorWebsiteButtonName
    | AmplitudeGalleryContactButtonName
    | AmplitudeGalleryMapButtonName
    | AmplitudeHomeMatchOnOffModalButtonName
    | AmplitudePostPriceRevealButtonName
    | AmplitudeListingMapButtonName
    | AmplitudeUnlockChoiceButtonName
    | AmplitudeUnlockChoiceExitButtonName
    | AmplitudeRegistrationWizardButtonName
    | AmplitudeFavouritesTopbarButtonName
    | AmplitudePersonalizedHomepageButtonName
    | AmplitudeReservationButtonName
    | AmplitudeUnlockChoiceReservationButtonName
    | AmplitudeSearchAiAssistantButtonName
    | AmplitudePricesCityButtonName
    | AmplitudeApartmentPricesButtonName
    | AmplitudeHotlineConsultantButtonName;

export type AmplitudeButtonCategory =
    | "investment_page"
    | "property_page"
    | "homematch"
    | "rp_multilead"
    | "listing_page"
    | "homepage"
    | "rp_see_apartments"
    | "listing_map"
    | "rp_hm_on_off_modal"
    | "rp_auth"
    | "rp_reservation"
    | "rp_post_price_reveal"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address"
    | "rp_apartment_prices_country"
    | "rp_hotline_consultant"
    | AmplitudeUnlockChoiceButtonCategory;

export type AmplitudeHomeMatchAction = "hm_on" | "hm_off";

interface ITrackAmplitudeButtonClickParams {
    buttonName: AmplitudeButtonName;
    buttonCategory: AmplitudeButtonCategory;
    itemId: number | null;
    propertyId?: number | null;
    buttonLink?: string | null;
    value?: string | null;
    itemListId?: string | null;
    rpHmMatchAction?: AmplitudeHomeMatchAction;
    /** Button-specific properties defined per placement in the Amplitude knowledge base. */
    additionalEventProperties?: Record<string, string | number | null>;
}

export const trackAmplitudeButtonClick = (params: ITrackAmplitudeButtonClickParams) => {
    trackAmplitudeEvent("button_click", {
        button_name: params.buttonName,
        button_category: params.buttonCategory,
        item_id: params.itemId,
        property_id: params.propertyId ?? null,
        button_link: params.buttonLink ?? null,
        ...(params.value != null && {value: params.value}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId}),
        ...(params.rpHmMatchAction != null && {rp_hm_match_action: params.rpHmMatchAction}),
        ...params.additionalEventProperties
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeOfferContactButtonName = "offer_show_number" | "offer_call_investor";
type AmplitudeOfferDetailNavButtonName = "view_floor_plan" | "view_map";
type AmplitudeConstructionGalleryButtonName = "view_construction_photos" | "view_construction_stages";
type AmplitudeLocationButtonName = "check_location_map";
type AmplitudeAreaPhotosButtonName = "view_area_photos" | "view_area_map";
type AmplitudeVendorReportButtonName = "download_developer_report";
type AmplitudeCreditCalculatorButtonName = "ask_property_with_mortgage" | "view_bank_offers";
type AmplitudeComparisonWidgetButtonName = "view_comparison_offers" | "rp_go_to_comparison";
type AmplitudeFavouritesTopbarButtonName = "rp_favourites_show_all";
type AmplitudeOfferListViewButtonName = "offers_view_toggle";
type AmplitudeVendorWebsiteButtonName = "view_developer_website";
type AmplitudeGalleryContactButtonName = "rp_gallery_show_number";
type AmplitudeGalleryMapButtonName = "check_travel_time";
type AmplitudeHomeMatchOnOffModalButtonName = "rp_hm_on_off_modal_confirm";
type AmplitudePostPriceRevealButtonName = "rp_post_price_reveal_browsing_only";
type AmplitudeSearchAiAssistantButtonName = "rp_search_ai_assistant";
export type AmplitudeUnlockChoiceButtonCategory =
    | "rp_post_price_reveal"
    | "rp_download_floor_plan"
    | "rp_price_history"
    | "rp_developer_report"
    | "rp_construction_photos"
    | "rp_area_photos"
    | "rp_faq";
export type AmplitudeUnlockChoiceButtonAction = "select" | "submit" | "close";
export type AmplitudeUnlockChoiceButtonName = `${AmplitudeUnlockChoiceButtonCategory}_${AmplitudeUnlockChoiceButtonAction}`;
export type AmplitudeUnlockChoiceExitButtonName = "rp_preferences_close" | "rp_price_negotiate_submit" | "rp_price_negotiate_close";
export type AmplitudeRegistrationWizardButtonName =
    | "rp_auth_continue"
    | "rp_auth_google"
    | "rp_auth_facebook"
    | "rp_auth_send_sms"
    | "rp_auth_resend_sms"
    | "rp_auth_discover_price"
    | "rp_auth_back"
    | "rp_auth_close";
type AmplitudeListingMapButtonName = "rp_listing_map_apartment_prev" | "rp_listing_map_apartment_next" | "ask_full_offer" | "see_property_details";
export type AmplitudePersonalizedHomepageButtonName =
    | "rp_homepage_recent_search"
    | "rp_homepage_recent_searches_show_more"
    | "rp_homepage_offers_for_you"
    | "rp_homepage_youtube_video"
    | "rp_homepage_youtube_channel"
    | "rp_homepage_consultant_call"
    | "rp_homepage_prices_show_more"
    | "rp_homepage_tinder_rate"
    | "rp_homepage_tinder_more_info"
    | "rp_homepage_tinder_see_all"
    | "rp_homepage_tinder_close";
export type AmplitudeReservationButtonName =
    | "rp_reservation_start"
    | "rp_reservation_code_submit"
    | "rp_reservation_code_resend"
    | "rp_reservation_close"
    | "rp_reservation_confirmed_close";
// the steps of the reservation started from the offer choice of the unlock choice modal
export type AmplitudeUnlockChoiceReservationButtonName = "rp_reservation_back" | "rp_reservation_close" | "rp_reservation_resend" | "rp_reservation_ack";
export type AmplitudePricesCityButtonName =
    | "rp_apartment_prices_area"
    | "rp_apartment_prices_place"
    | "rp_apartment_prices_nearby_offers_arrow"
    | "rp_apartment_prices_price_stat";
export type AmplitudeApartmentPricesButtonName =
    | "rp_apartment_prices_place"
    | "rp_apartment_prices_short"
    | "rp_apartment_prices_shorts_arrow"
    | "rp_apartment_prices_faq_arrow"
    | "rp_apartment_prices_cheapest_offers_arrow"
    | "rp_apartment_prices_popular_location";
export type AmplitudeHotlineConsultantButtonName = "rp_hotline_consultant_show_similar";

type AmplitudeButtonName =
    | AmplitudeOfferContactButtonName
    | AmplitudeOfferDetailNavButtonName
    | AmplitudeConstructionGalleryButtonName
    | AmplitudeLocationButtonName
    | AmplitudeAreaPhotosButtonName
    | AmplitudeVendorReportButtonName
    | AmplitudeCreditCalculatorButtonName
    | AmplitudeComparisonWidgetButtonName
    | AmplitudeOfferListViewButtonName
    | AmplitudeVendorWebsiteButtonName
    | AmplitudeGalleryContactButtonName
    | AmplitudeGalleryMapButtonName
    | AmplitudeHomeMatchOnOffModalButtonName
    | AmplitudePostPriceRevealButtonName
    | AmplitudeListingMapButtonName
    | AmplitudeUnlockChoiceButtonName
    | AmplitudeUnlockChoiceExitButtonName
    | AmplitudeRegistrationWizardButtonName
    | AmplitudeFavouritesTopbarButtonName
    | AmplitudePersonalizedHomepageButtonName
    | AmplitudeReservationButtonName
    | AmplitudeUnlockChoiceReservationButtonName
    | AmplitudeSearchAiAssistantButtonName
    | AmplitudePricesCityButtonName
    | AmplitudeApartmentPricesButtonName
    | AmplitudeHotlineConsultantButtonName;

export type AmplitudeButtonCategory =
    | "investment_page"
    | "property_page"
    | "homematch"
    | "rp_multilead"
    | "listing_page"
    | "homepage"
    | "rp_see_apartments"
    | "listing_map"
    | "rp_hm_on_off_modal"
    | "rp_auth"
    | "rp_reservation"
    | "rp_post_price_reveal"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address"
    | "rp_apartment_prices_country"
    | "rp_hotline_consultant"
    | AmplitudeUnlockChoiceButtonCategory;

export type AmplitudeHomeMatchAction = "hm_on" | "hm_off";

interface ITrackAmplitudeButtonClickParams {
    buttonName: AmplitudeButtonName;
    buttonCategory: AmplitudeButtonCategory;
    itemId: number | null;
    propertyId?: number | null;
    buttonLink?: string | null;
    value?: string | null;
    itemListId?: string | null;
    rpHmMatchAction?: AmplitudeHomeMatchAction;
    /** Button-specific properties defined per placement in the Amplitude knowledge base. */
    additionalEventProperties?: Record<string, string | number | null>;
}

export const trackAmplitudeButtonClick = (params: ITrackAmplitudeButtonClickParams) => {
    trackAmplitudeEvent("button_click", {
        button_name: params.buttonName,
        button_category: params.buttonCategory,
        item_id: params.itemId,
        property_id: params.propertyId ?? null,
        button_link: params.buttonLink ?? null,
        ...(params.value != null && {value: params.value}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId}),
        ...(params.rpHmMatchAction != null && {rp_hm_match_action: params.rpHmMatchAction}),
        ...params.additionalEventProperties
    });
};
